import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { ProductDetail } from '@/types/product-detail';
import { BatchAddCartFailMessage } from '@/types/mini-cart';
interface ProductDetailState {
  productDetail: ProductDetail;
  batchAddFailMessage: BatchAddCartFailMessage[];
  faliPriceSkus: string[];
  setProductDetail: (productDetail: ProductDetail) => void;
  setBatchAddFailMessage: (failMessage: BatchAddCartFailMessage[]) => void;
  setFaliPriceSkus: (failSkus: string[]) => void;
}

export const useProductDetailStore = create<ProductDetailState>()(
  devtools(
    immer((set) => ({
      productDetail: null,
      setProductDetail: (productDetail) => {
        set((state) => {
          state.productDetail = productDetail;
        });
      },
      batchAddFailMessage: [],
      setBatchAddFailMessage: (failMessage) => {
        set((state) => {
          state.batchAddFailMessage = failMessage;
        });
      },
      faliPriceSkus: [],
      setFaliPriceSkus: (failSkus) => {
        set((state) => {
          state.faliPriceSkus = failSkus;
        });
      },
    })),
    {
      name: 'product-detail',
    }
  )
);
